// src/Components/ShippingForm/FormField.js
import React from "react";
import "./FormField.css";

export default function FormField({
  label,
  name,
  value,
  onChange,
  required = false,
  type = "text",
  options, // [{code,name}] for select
}) {
  const hasValue = value !== undefined && value !== null && String(value).trim() !== "";

  return (
    <div className={`form-group ${hasValue ? "has-value" : ""}`}>
      {options ? (
        <select name={name} value={value || ""} onChange={onChange} required={required}>
          <option value="" disabled hidden></option>
          {options.map((opt) => (
            <option key={opt.code} value={opt.code}>
              {opt.name}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          value={value || ""}
          onChange={onChange}
          required={required}
        />
      )}

      <label>{label}</label>
    </div>
  );
}